// Buffer circulaire global des dernières erreurs console / runtime.
// Auto-initialisé à l'import (effet de bord). Utilisé par le système de support
// pour joindre automatiquement les 50 dernières erreurs à un signalement.

const MAX_ENTRIES = 50;
const buffer = [];

function pushEntry(entry) {
  try {
    buffer.push({ ...entry, ts: new Date().toISOString() });
    if (buffer.length > MAX_ENTRIES) buffer.shift();
  } catch (_) {
    /* noop — ne jamais casser l'app pour un log */
  }
}

function safeStringify(arg) {
  if (typeof arg === 'string') return arg;
  if (arg instanceof Error) return `${arg.name}: ${arg.message}`;
  try {
    return JSON.stringify(arg);
  } catch (_) {
    return String(arg);
  }
}

if (typeof window !== 'undefined' && !window.__komercesErrorBufferInstalled) {
  window.__komercesErrorBufferInstalled = true;

  // Erreurs runtime non capturées
  window.addEventListener('error', (e) => {
    pushEntry({
      type: 'error',
      message: (e && e.message) || 'Erreur inconnue',
      source: e && e.filename,
      line: e && e.lineno,
      col: e && e.colno,
      stack: e && e.error && e.error.stack ? String(e.error.stack).slice(0, 1200) : undefined,
    });
  });

  // Rejets de promesses non gérés
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e && e.reason;
    pushEntry({
      type: 'unhandledrejection',
      message: (reason && reason.message) || safeStringify(reason),
      stack: reason && reason.stack ? String(reason.stack).slice(0, 1200) : undefined,
    });
  });

  // Interception de console.error (sans casser le comportement natif)
  const originalConsoleError = console.error;
  console.error = (...args) => {
    pushEntry({
      type: 'console.error',
      message: args.map(safeStringify).join(' ').slice(0, 1200),
    });
    originalConsoleError.apply(console, args);
  };
}

export function getConsoleErrors() {
  return buffer.slice();
}

export function clearConsoleErrors() {
  buffer.length = 0;
}
